import _ from 'lodash'
import attributes from '../settings/attributes.json'
import serenity from '../settings/attributes.zh.json'
import devSettings from '../settings/attributes.dev.json'

// To prevent repeated processing of attributes
const processed = {}

// Function to combine the base attributes
// and ones to overwrite
const combine = (base, target) => {
    // Clone the base attributes
    const clone = { ...base }

    // Reduce the content we want to go through
    // only find entries that exist to be overwritten
    const reduced = _.reduce(
        base,
        (result, value, key) => {
            // Make sure the target value exists to overwrite
            if (target[key]) result[key] = value

            return result
        },
        {},
    )

    // Loop through the reduced list and recursively find the full depth
    // of keys to be overwriteen
    _.forOwn(reduced, (value, key) => {
        if (typeof base[key] === 'object' && !Array.isArray(base[key]) && target[key]) {
            clone[key] = combine(base[key], target[key])
        } else if (target[key]) {
            clone[key] = target[key]
        }
    })

    return clone
}

const getAttributes = (locale) => {
    // If the requested locale has already been processed
    // return the stored value
    if (locale != null && processed[locale]) return processed[locale]

    let result

    switch (locale) {
        case 'zh':
            result = combine(attributes, serenity)
            break

        default:
            result = attributes
    }

    if (process.env.NODE_ENV === 'development') {
        result = combine(result, devSettings)
    }

    if (locale) {
        processed[locale] = result
    }

    return result
}

export default getAttributes



// WEBPACK FOOTER //
// ./src/store/attributes.js